// ============================================================================
// /meet — point expert offert (campagnes de retargeting).
//   Le visiteur connaît déjà Manager IA : on va droit au rendez-vous.
//   L'offre : 20 minutes avec un expert pour résoudre en direct un maximum de
//   ses problématiques IA ; pour les plus profondes, une roadmap.
//   Toute la copie de la page vit ici (composants = présentation pure).
// ============================================================================

export const MEET_DURATION_MIN = 20;

export const MEET_HERO = {
  badge: "Point expert offert · 20 min",
  headline: "Posez vos blocages IA à un expert. Repartez avec les réponses.",
  promise:
    "20 minutes en visio, offertes. On règle en direct un maximum de vos problématiques IA. Pour les sujets plus profonds, vous repartez avec une roadmap claire : quoi faire, dans quel ordre, avec quels outils.",
  cta: "Choisir mon créneau",
  hint: "Offert · 20 min · en visio · sans engagement",
  proof: "Plus de 3 000 collaborateurs formés dans 35 entreprises.",
};

/** Ce que la personne obtient — icônes de @/components/Icon. */
export const MEET_BENEFITS: { icon: string; title: string; body: string }[] = [
  {
    icon: "chat",
    title: "Vos questions réglées en direct",
    body: "Un prompt qui ne donne rien, un outil bloqué par la DSI, un cas d’usage qui patine : l’expert le traite avec vous pendant l’appel.",
  },
  {
    icon: "rise",
    title: "Une roadmap pour le reste",
    body: "Les problématiques plus profondes repartent avec un plan : les étapes, l’ordre, les outils. Vous la gardez, que l’on travaille ensemble ensuite ou non.",
  },
  {
    icon: "build",
    title: "Dans votre environnement réel",
    body: "Vos outils, vos contraintes IT, vos données. Pas une démo faite sur la machine de quelqu’un d’autre.",
  },
];

export const MEET_CALENDAR = {
  title: "Choisissez votre créneau",
  subtitle: "20 minutes en visio. Vous recevez la confirmation et le lien de connexion par email.",
};

/** Après la popup de sortie (formulaire rempli, pas de créneau pris). */
export const MEET_CALLBACK = {
  title: "C’est noté. Un expert vous rappelle.",
  body: "On vous appelle pour caler votre point au moment qui vous arrange.",
  qualifiedExtra: "Un créneau vous tente quand même ? Il reste accessible juste en dessous.",
  cta: "Voir les créneaux",
};

/** /meet/ty — préparation du point. */
export const MEET_TY = {
  badge: "Demande envoyée ✅",
  title: "C’est noté. Préparez vos questions.",
  intro:
    "vous recevez la confirmation de votre créneau et le lien de connexion par email (vérifiez vos spams, au cas où).",
  prepTitle: "Pour régler un maximum de sujets en 20 minutes, notez :",
  prep: [
    ["Vos 2 ou 3 blocages IA", "ce qui ne marche pas, ou ce que vous n’arrivez pas à lancer."],
    ["Vos outils", "Microsoft 365, Google, Copilot, ChatGPT, Claude… et ce que votre DSI autorise."],
    ["Un exemple concret", "un document, une tâche ou un mail récurrent sur lequel travailler en direct."],
  ] as [string, string][],
  outro: "Un imprévu ? Vous pouvez décaler depuis l’email de confirmation.",
};
